module.exports = __webpack_public_path__ + "static/media/tax.fed3eb80.svg";